import { __extends } from "tslib";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import PremiumFolderIcon from '../PremiumFolderIcon';
import selectableDeviationWrapperStyles from './SelectableDeviationWrapper.scss';
var enhance = compose(withSelectedDeviations);
var SelectableDeviationWrapper = /** @class */ (function (_super) {
    __extends(SelectableDeviationWrapper, _super);
    function SelectableDeviationWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onToggleSelect = function () {
            _this.props.onSelectableItemClick(_this.props.deviation);
        };
        return _this;
    }
    SelectableDeviationWrapper.prototype.render = function () {
        var _a = this.props, deviation = _a.deviation, selectionLimit = _a.selectionLimit, selectedDeviations = _a.selectedDeviations, canSelectMore = _a.canSelectMore, className = _a.className;
        var isSelected = !!selectedDeviations.find(function (selectedDeviation) {
            return selectedDeviation.typeId === deviation.typeId &&
                selectedDeviation.deviationId === deviation.deviationId;
        });
        var isDisabled = this.props.isDisabled ||
            (selectionLimit > 1 && !isSelected && !canSelectMore);
        return (React.createElement("div", { className: classnames(selectableDeviationWrapperStyles['root'], isSelected && selectableDeviationWrapperStyles['selected'], isDisabled && selectableDeviationWrapperStyles['disabled'], className), draggable: false, onClick: this.onToggleSelect },
            isSelected && (React.createElement(CheckIcon, { className: selectableDeviationWrapperStyles['check'] })),
            React.createElement(PremiumFolderIcon, { deviation: deviation, className: selectableDeviationWrapperStyles['premium-icon'] }),
            this.props.children));
    };
    return SelectableDeviationWrapper;
}(React.Component));
export { SelectableDeviationWrapper };
export default enhance(SelectableDeviationWrapper);
//# sourceMappingURL=SelectableDeviationWrapper.connected.js.map